import React from 'react';
import styles from './Skeletons.module.css';

function DoughnutSkeleton() {
    return (
        <div className={styles.doughnutSkeleton}>
            <svg viewBox="0 0 100 100">
                <circle className={styles.doughnutSkeletonBg} cx="50" cy="50" r="40" />
                <circle className={styles.doughnutSkeletonShimmer} cx="50" cy="50" r="40" />
            </svg>
        </div>
    );
}

export default DoughnutSkeleton;
